module.exports = __webpack_public_path__ + "img/biotekno-logo.e99a0a90.svg";